import React, { useState, useEffect } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useDataProvider, useTranslate, } from 'react-admin';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
    },
}));

const basicOptions = (field) => ({
    pagination: { page: 1, perPage: 100 },
    sort: { field, order: 'ASC' },
    filter: {},
});

const ParamSelectInput = ({
    optionValue = 'id',
    optionText = 'descripcion',
    resource,
    onChange = (value) => console.warn('Define onChange param to handle select changes', value),
}) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const [item, setItem] = React.useState('');
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const handleChange = (event) => {
        setItem(event.target.value);
        onChange(event.target.value);
    };

    useEffect(() => {
        const listOptions = basicOptions(optionText);
        dataProvider.getList(resource, listOptions)
            .then(({ data }) => {
                setList(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, [resource, optionText, dataProvider]);

    if (loading) {
        return (<LinearProgress />);
    }
    if (error) {
        return (<pre>{JSON.stringify(error)}</pre>);
    }

    return (
        <FormControl className={classes.formControl}>
            <InputLabel>{translate(`resources.${resource}.name`, 1)}</InputLabel>
            <Select
                value={item}
                onChange={handleChange} >
                    <MenuItem value=""><em></em></MenuItem>
                    {list.map((listItem, i) =>
                        <MenuItem key={i} value={listItem[optionValue]}>{listItem[optionText]}</MenuItem>
                    )}
            </Select>
        </FormControl>
    );
};

export default ParamSelectInput;
